/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */
/* eslint-disable */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import SVG from 'react-inlinesvg';
import Granim from 'granim';
import s from './Header.css';
import Link from '../../../components/Link';
import logoUrl from './icon.png';
import logoUrl2x from './icon@2x.png';
import appStoreDownload from './app-store-download.png';
import appStoreDownload2x from './app-store-download@2x.png';
import googlePlayDownload from './google-play-download.png';
import googlePlayDownload2x from './google-play-download@2x.png';
import phoneHeader from './phone-header.png';
import phoneHeader2x from './phone-header@2x.png';
// import juggling from './juggling.svg';
import juggling from './juggling_animated.svg';
// import meditating from './meditating.svg';
import meditating from './meditating_animated.svg';
import { isIOS, isAndroid, isBrowser } from 'react-device-detect';

const APP_STORE_URL = 'https://itunes.apple.com/app/id1471098086';
const GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=com.holgersindbaek.habitual';

class Header extends React.Component {
  state = {
    windowHeight: 1100,
  };

  componentDidMount() {
    this.setState({
      windowHeight:
        window.innerWidth < 768
          ? 1300
          : Math.min(Math.max(window.innerHeight, 900), 1100),
    });

    const granimInstance = new Granim({
      element: '#header-granim-canvas',
      name: 'granim',
      opacity: [1, 1],
      direction: 'diagonal',
      isPausedWhenNotInView: false,
      stateTransitionSpeed: 160,
      states: {
        'default-state': {
          gradients: [['#E7F5FF', '#A5D8FF'], ['#A5D8FF', '#E7F5FF']],
        },
      },
      onStart: () => {
        setTimeout(() => {
          document.querySelector('#header-granim-canvas').style.opacity = 1;
        }, 320);
      },
    });
  }

  loadAnimations = () => {
    const { jugglingRef, meditatingRef } = this.refs;

    if (
      jugglingRef.state.status == 'ready' &&
      meditatingRef.state.status == 'ready'
    ) {
      setTimeout(() => {
        document.querySelectorAll('.juggling *').forEach(element => {
          element.style['animation-iteration-count'] = 'infinite';
        });
        document.querySelectorAll('.meditating *').forEach(element => {
          element.style['animation-iteration-count'] = 'infinite';
        });
        document.querySelector('.juggling').style.opacity = 1;
        document.querySelector('.meditating').style.opacity = 1;
      }, 320);
    }
  };

  render() {
    const showIOSDownloadLink = isIOS || isBrowser;
    const showAndroidDownloadLink = isAndroid || isBrowser;
    const primaryDownloadUrl = isAndroid ? GOOGLE_PLAY_URL : APP_STORE_URL;

    return (
      <div className={s.root}>
        <canvas id="header-granim-canvas" className={s.granim} />
        <div
          className={s.container}
          style={{ height: `${this.state.windowHeight}px` }}
        >
          <div className={s.navigation}>
            <Link className={s.brand} to="/">
              <img
                src={logoUrl}
                srcSet={`${logoUrl2x} 2x`}
                width="58"
                height="58"
                alt="Habitual"
              />
              <span className={s.brandText}>Habitual</span>
            </Link>
            <div className={s.download}>
              <a
                target="_blank"
                className={s.downloadLink}
                href={primaryDownloadUrl}
              >
                Download
              </a>
              <p className={s.downloadText}>Get started for free</p>
            </div>
          </div>
          <div className={s.banner}>
            <h1 className={s.bannerTitle}>
              Track habits, build <br className={s.desktop} />routines & accomplish goals.
            </h1>
            <p className={s.bannerBody}>
              Habitual is a habit tracker that helps you <br className={s.desktop} />form great habits, reach your goals and <br className={s.desktop} />get your life in balance.
            </p>
            <div className={s.appStoreContainer}>
              {showIOSDownloadLink &&
                <a
                  target="_blank"
                  className={s.appStoreLink}
                  href={APP_STORE_URL}
                >
                  <img
                    src={appStoreDownload}
                    srcSet={`${appStoreDownload2x} 2x`}
                    width="212"
                    height="72"
                    alt="App store link"
                  />
                </a>
              }
              <span></span>
              {showAndroidDownloadLink &&
                <a
                  target="_blank"
                  className={s.googlePlayLink}
                  href={GOOGLE_PLAY_URL}
                >
                  <img
                    src={googlePlayDownload}
                    srcSet={`${googlePlayDownload2x} 2x`}
                    width="212"
                    height="72"
                    alt="Google play link"
                  />
                </a>
              }
            </div>
          </div>
          <div className={s.phone}>
            <div className={s.juggling}>
              <SVG ref="jugglingRef" src={juggling} onLoad={this.loadAnimations} />
            </div>
            <div className={s.meditating}>
              <SVG
                ref="meditatingRef"
                src={meditating}
                onLoad={this.loadAnimations}
              />
            </div>
            <div className={s.phone_overflow}>
              <img
                src={phoneHeader}
                srcSet={`${phoneHeader2x} 2x`}
                width="423"
                height="845"
                alt="iOS app screenshot"
              />
            </div>
          </div>
        </div>
        <div className={s.bottomBorder} />
      </div>
    );
  }
}

export default withStyles(s)(Header);
